<template>
  <div>
    <h2>
      <span class="form-group">
        Preventive Animal Health and Vaccination
        <comments field-name="heading_preventive_animal_health_and_vaccination" :isReadOnly="isReadOnly"></comments>
      </span>
    </h2>

    <h3 class="text-left">
      <span class="form-group">
        BVD Testing Results
        <comments field-name="heading_bvd_testing_results_vetsouth" :isReadOnly="isReadOnly"></comments>
      </span>
    </h3>
    <div v-if="(getChartData('bvd_results') || []).length > 0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Supply</th>
            <th>Vet</th>
            <th>Test Type</th>
            <th>Description</th>
            <th>Animals Tested</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bvd, index) in getChartData('bvd_results')" :key="index">
            <td class="text-left">{{ bvd[0] }}</td>
            <td class="text-left">{{ bvd[1] }}</td>
            <td class="text-left">{{ bvd[2] }}</td>
            <td class="text-left">{{ bvd[3] }}</td>
            <td class="text-left">{{ bvd[4] }}</td>
            <td class="text-left">{{ bvd[5] }}</td>
            <td class="text-left">{{ bvd[6] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="text-left">No Results</p>
    </div>

    <br />

    <h3 class="text-left">
      BVD Bulk Milk Testing Results (LIC - spreadsheet)
      <comments field-name="heading_bvd_testing_results_lic" :isReadOnly="isReadOnly"></comments>
    </h3>
    <div v-if="getChartData('lic_bvd_results').length > 0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Collected Date</th>
            <th>Supply</th>
            <th>PCR</th>
            <th>AbELISA</th>
            <th>Type</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(bvd, index) in getChartData('lic_bvd_results')" :key="index">
            <td class="text-left">{{ bvd['Collected Date'] }}</td>
            <td class="text-left">{{ bvd['Supply'] }}</td>
            <td class="text-left">{{ bvd['PCR'] }}</td>
            <td class="text-left">{{ bvd['AbELISA'] }}</td>
            <td class="text-left">{{ bvd['Type'] }}</td>
            <td class="text-left">{{ bvd['Comment'] }}</td>
          </tr>
          <tr>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="text-left">No Results</p>
    </div>

    <!-- <h3 class="text-left"> -->
    <!--   <span class="form-group"> BVD Testing Results (spreadsheet data) </span> -->
    <!-- </h3> -->
    <!-- <div v-if="(getChartData('bvd_spreadsheet_results') || []).length > 0"> -->
    <!--   <small class="text-muted"> -->
    <!--     Some results shown here may repeat those shown above but are included here for completeness -->
    <!--   </small> -->
    <!--   <table class="table table-bordered"> -->
    <!--     <thead> -->
    <!--       <tr> -->
    <!--         <th>Season</th> -->
    <!--         <th>Source</th> -->
    <!--         <th>Herd</th> -->
    <!--         <th>Visit</th> -->
    <!--         <th>AbELISA</th> -->
    <!--         <th>SP</th> -->
    <!--         <th>PCR</th> -->
    <!--       </tr> -->
    <!--     </thead> -->
    <!--     <tbody> -->
    <!--       <tr v-for="(bvd, index) in getChartData('bvd_spreadsheet_results')" :key="index"> -->
    <!--         <td class="text-left">{{ bvd['Season'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['Source'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['Herd'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['Visit'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['AbELISA'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['SP'] }}</td> -->
    <!--         <td class="text-left">{{ bvd['PCR'] }}</td> -->
    <!--       </tr> -->
    <!--     </tbody> -->
    <!--   </table> -->
    <!-- </div> -->
    <!-- <div v-else> -->
    <!--   <p class="text-left">No Results</p> -->
    <!-- </div> -->

    <div class="step-section text-left">
      <h3 class="text-center">
        <span class="form-group">BVD Monitoring Requirements</span>
      </h3>
      <hr />

      <div v-for="farm in FARMS" :key="`farm_bvd-${farm.id}`">
        <div class="row">
          <div class="col-md-4">
            <h4>{{ farm.farm_label }}</h4>
          </div>
          <div class="col-md-2">
            <check-box
              label="Bulk Milk LIC"
              :field-name="prefixedField('wants_bvd_mon_lic', farm.id)"
              :addEmailNotification="true"
              :disabled="isReadOnly"
              :show-input-box="false"
            >
            </check-box>
          </div>
          <div class="col-md-2">
            <check-box
              label="Bulk Milk Gribbles"
              :addEmailNotification="true"
              :field-name="prefixedField('wants_bvd_mon_gribbles', farm.id)"
              :disabled="isReadOnly"
              :show-input-box="false"
            >
            </check-box>
          </div>
          <div class="col-md-2">
            <check-box
              label="Other"
              :field-name="prefixedField('wants_bvd_mon_other', farm.id)"
              :disabled="isReadOnly"
              :show-input-box="false"
            >
            </check-box>
          </div>
          <div class="col-md-2">
            <check-box
              label="Vaccination"
              :field-name="`farm_${farm.id}-wants_bvd_mon_vax`"
              :disabled="isReadOnly"
              :show-input-box="false"
            >
            </check-box>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4>R2s</h4>
        </div>
        <div class="col-md-2">
          <check-box
            label="Individual Ag"
            field-name="wants_bvd_mon_r2_ind_ag"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2">
          <check-box
            label="Pre Mating Ab"
            field-name="wants_bvd_mon_r2_premate_ab"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
          <check-box
            label="Vaccination"
            field-name="wants_bvd_mon_r2_vax"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4>Calves</h4>
        </div>
        <div class="col-md-2">
          <check-box
            label="Individual Ag"
            field-name="wants_bvd_mon_r1_ind_ag"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2">
          <check-box
            label="Post Winter Ab"
            field-name="wants_bvd_mon_r1_winter_ab"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
          <check-box
            label="Vaccination"
            field-name="wants_bvd_mon_r1_vax"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4>Bulls</h4>
        </div>
        <div class="col-md-2">
          <check-box
            label="Individual Ag"
            field-name="wants_bvd_mon_bull_ind_ag"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2">
          <check-box
            label="Post Winter Ab"
            field-name="wants_bvd_mon_bull_winter_ab"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
          <check-box
            label="Vaccination"
            field-name="wants_bvd_mon_bull_vax"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
      </div>

      <br />
      <div class="text-center">
        <discussion-points
          title="BVD Monitoring Requirements Notes and notes for farm services"
          comments-field="bvd_monitoring_requirements_notes"
          points="Testing and vaccination specifics - ear notches vs blood, timing, Gribbles/LIC bulk milk package. Will the calves need tested at disbudding time?- add to young stock page.Please specify details for farm services including the package options and dates for tests"
        >
        </discussion-points>
      </div>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(FARMS) + 'px' }">
      <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
        <h3>{{ farm.farm_label }}</h3>

        <fieldset>
          <discussion-points
            title="Johnes Disease"
            :comments-field="`farm_${farm.id}-other_issues_johnes`"
            points="Do you want to herd test? Which test? When? Please add details to comments."
          >
          </discussion-points>

          <radio-input
            label="Do you want to Johnes test?"
            :field-name="`farm_${farm.id}-wants_herd_test`"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
              { value: 'Maybe', display: 'Maybe' },
            ]"
            :disabled="isReadOnly"
          >
          </radio-input>
        </fieldset>
      </div>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(FARMS) + 'px' }">
      <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
        <h3>{{ farm.farm_label }}</h3>

        <fieldset>
          <legend>
            <span class="form-group">
              Salmonella Vaccination
              <comments :field-name="`farm_${farm.id}-heading_salmonella_vaccination`" :isReadOnly="isReadOnly">
              </comments>
            </span>
          </legend>

          <radio-input
            label="Salmonella Vaccination?"
            :field-name="`farm_${farm.id}-wants_salmonella_vaccine`"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
            :disabled="isReadOnly"
          >
          </radio-input>

          <!-- <template v-if="getFieldValue(`farm_${farm.id}-wants_salmonella_vaccine`) == 'Yes'"> -->
          <div class="text-left">
            <p>Select Salmonella vaccine from drug allocations below</p>

            <check-box
              label="First time user"
              :disabled="isReadOnly"
              :field-name="`farm_${farm.id}-is_first_time_salmonella_vax_user`"
            >
            </check-box>

            <check-box
              label="Continuous user"
              :disabled="isReadOnly"
              :field-name="`farm_${farm.id}-is_continuous_salmonella_vax_user`"
            >
            </check-box>
          </div>

          <!-- </template> -->
        </fieldset>
      </div>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(FARMS) + 'px' }">
      <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
        <h3>{{ farm.farm_label }}</h3>

        <fieldset>
          <legend>Scour Vaccination</legend>
          <div class="alert alert-info">
            <template v-if="hasDCScourVaccinationInfo(farm)">
              <p><strong>Dry cow order details.</strong></p>
              <p v-if="getFieldValue(prefixedField('dc_wants_scour_vaccine', farm.id))">
                <strong>Wants scour vaccine:</strong>
                {{ getFieldValue(prefixedField('dc_wants_scour_vaccine', farm.id)) }}
              </p>
              <p v-if="getFieldValue(prefixedField('dc_scour_vaccine_req_date', farm.id))">
                <strong>Vaccine required Date:</strong>
                {{ getFieldValue(prefixedField('dc_scour_vaccine_req_date', farm.id)) }}
              </p>
              <p v-if="getFieldValue(prefixedField('dc_scour_vax_comments', farm.id))">
                <strong>Dry consult comments:</strong>
                {{ getFieldValue(prefixedField('dc_scour_vax_comments', farm.id)) }}
              </p>
              <p v-if="getFieldValue(prefixedField('dc_scour_vaccine_product_and_doses_req', farm.id))">
                <strong>Order notes:</strong>
                {{ getFieldValue(prefixedField('dc_scour_vaccine_product_and_doses_req', farm.id)) }}
              </p>
            </template>
            <template v-else>
              <p>No previous scour order info was found</p>
            </template>
          </div>

          <radio-input
            label="Scour vaccine?"
            :field-name="`farm_${farm.id}-wants_scour_vaccine`"
            subtext="Please select 'Yes' if you want to add or adjust scour vaccine allocations. An order email will be sent to retail if 'Yes' is selected. select Scour vaccine from Drug Allocations below"
            :commentFieldName="`farm_${farm.id}-wants_scour_vaccine_comments`"
            :addComment="true"
            :addEmailNotification="true"
            :choices="[
              { value: 'Yes', display: 'Yes' },
              { value: 'No', display: 'No' },
            ]"
            :disabled="isReadOnly"
          >
          </radio-input>

          <date-input
            label="Date required"
            :field-name="`farm_${farm.id}-scour_vaccine_req_date`"
            :disabled="isReadOnly"
          >
          </date-input>
        </fieldset>
      </div>
    </div>

    <h3 class="text-left">Lepto Products Purchased</h3>
    <div v-if="(getChartData('lepto_purchases') || []).length > 0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal</th>
            <th>Product</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lp, index) in getChartData('lepto_purchases')" :key="index">
            <td class="text-left">{{ lp[0] }}</td>
            <td class="text-left">{{ lp[1] }}</td>
            <td class="text-left">{{ lp[2] }}</td>
            <td class="text-left">{{ lp[3] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="text-left">No Results</p>
    </div>

    <div class="step-section text-left">
      <h3 class="text-left">
        <span class="form-group">
          Lepto Vaccination
          <comments field-name="heading_lepto_vaccination" :isReadOnly="isReadOnly"></comments>
        </span>
      </h3>
			<br>
			<div v-if="getFieldValue('dry_cow_lepto_comment')">
				<span>
				<strong>Dry Cow Consult Comments:</strong>
					{{getFieldValue('dry_cow_lepto_comment')}}
				</span>
			</div>
			<hr>

      <div class="alert alert-info">
        The est. animal number values shown here are prepopulated from the animal numbers entered earlier in the animal
        numbers step. Changing the estimated number of animals on this page does not change the numbers entered in the
        animal numbers step.
        <br />
        If you want to make changes to the original animal numbers and refresh the estimated numbers on this page, set
        the estimated numbers to blank before modifying the animal numbers page.
        <br />
        <a href="#" @click="setSection('AnimalNumbers')"> Go to animal numbers page. </a>
      </div>

      <div class="row">
        <div class="col-md-3"><strong>Calves</strong></div>
        <div class="col-md-3"><strong>Month</strong></div>
        <div class="col-md-3"><strong>Vax Type</strong></div>
        <div class="col-md-3"><strong>Est. number of animals</strong></div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input label="" placeholder="1st Shot" :disabled="true" :show-input-box="false"> </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="first_shot_month"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="first_shot_vax_type"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input
            label=""
            field-name="first_shot_est_number_animals"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input label="" placeholder="2nd Shot" :disabled="true" :show-input-box="false"> </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="second_shot_month"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="second_shot_vax_type"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input
            label=""
            field-name="second_shot_est_number_animals"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input label="" placeholder="3rd Shot" :disabled="true" :show-input-box="false"> </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="third_shot_month"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="third_shot_vax_type"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input
            label=""
            field-name="third_shot_est_number_animals"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>
      <h4>Herds and Heifers</h4>
      <div class="row">
        <div class="col-md-3"><strong>Animal</strong></div>
        <div class="col-md-3"><strong>Month</strong></div>
        <div class="col-md-3"><strong>Vax Type</strong></div>
        <div class="col-md-3"><strong>Est. number of animals</strong></div>
      </div>
      <div class="row" v-for="farm in FARMS" :key="`aniamlrow-${farm.id}`">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input label="" :placeholder="farm.farm_label" :disabled="true" :show-input-box="false"> </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            :field-name="`animallmdata_${farm.id}-month`"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            :field-name="`animallmdata_${farm.id}-vax_type`"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input
            label=""
            :field-name="`animallmdata_${farm.id}-est_number_animals`"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input label="" placeholder="Heifers" :disabled="true" :show-input-box="false"> </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="heifers_month"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="heifers_vax_type"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input label="" field-name="heifers_est_number_animals" :disabled="isReadOnly" :show-input-box="false">
          </number-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <span class="form-group"><label>  </label></span>
          <text-input
            label=""
            field-name="other_animal_name"
            placeholder="Other (Beef, Bull, etc)"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
            >
          </text-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="other_animal_month"
            :disabled="isReadOnly"
            :options="monthOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <select-input
            label=""
            field-name="other_animal_vax_type"
            :disabled="isReadOnly"
            :options="vaxTypeOptions"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-3">
          <number-input
            label=""
            field-name="other_animal_est_number_animals"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <select-input
            label="Programme Type?"
            field-name="lepto_vax_program"
            :disabled="isReadOnly"
            :options="[
              { value: 'Vet Vaccinated', display: 'Vet Vaccinated' },
              { value: 'Lepto QA', display: 'Lepto QA' },
              { value: 'Lepto QA Vet Vaccinated', display: 'Lepto QA Vet Vaccinated' },
              { value: 'Does not vaccinate', display: 'Does not vaccinate' },
            ]"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-4">
          <select-input
            label="Vaccination Completed in?"
            field-name="lepto_vax_completed_in"
            :disabled="isReadOnly"
            :options="[
              { value: 'May', display: 'May' },
              { value: 'December', display: 'December' },
              { value: 'Not Applicable', display: 'Not Applicable' },
            ]"
            :show-input-box="false"
          >
          </select-input>
        </div>
        <div class="col-md-4">
          <number-input
            label="Numbers of Pigs on Farm?"
            field-name="pigs_on_farm"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </number-input>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12 form-group">
          <check-box
            label="Vaccination program completed"
            field-name="is_lepto_vax_program_completed"
            :addEmailNotification="true"
            :addComment="true"
            commentFieldName="lepto_vax_program_completion_certificate_notes"
            @on-change="toggleNotifications"
            :disabled="isReadOnly"
            :show-input-box="false"
          >
          </check-box>
        </div>
      </div>
    </div>

    <drug-allocation-cart :farms="FARMS" :drugs="getFieldValue('DRUGS')" :isReadOnly="isReadOnly">
    </drug-allocation-cart>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './DrugAllocationCart'

export default {
  name: 'PreventiveHealthAndVacination',
  mixins: [baseComponent],
  mounted() {
    this.prepopulateLeptoFields()
  },
  components: {
    DrugAllocationCart,
  },
  methods: {
    ...mapActions('currentConsult', ['setSection']),
    hasDCScourVaccinationInfo: function (farm) {
      return [
        'dc_wants_scour_vaccine',
        'dc_scour_vaccine_req_date',
        'dc_scour_vax_comments',
        'dc_scour_vaccine_product_and_doses_req',
      ].some((field) => {
        return Boolean(this.getFieldValue(this.prefixedField(field, farm.id), this.$options.name))
      })
    },
    prepopulateLeptoFields: function () {
      // Prepopulate lepto fields https://basecamp.com/2638249/projects/7913146/todos/461254892
      // Prepopulate calves
      let calvesEstNumberFields = [
        'first_shot_est_number_animals',
        'second_shot_est_number_animals',
        'third_shot_est_number_animals',
      ]
      if (!calvesEstNumberFields.every((field) => this.getFieldValue(field))) {
        let estNumberCalves = this.FARMS.map((farm) => this.prefixedField('r1', farm.id))
          .map((field) => this.getFieldValue(field, 'AnimalNumbers') || 0)
          .reduce((partialSum, a) => partialSum + a, 0)
        for (let field of calvesEstNumberFields) {
          if ([null, undefined].includes(this.getFieldValue(field))) {
            if (estNumberCalves && estNumberCalves > 0) {
              this.setFieldValue({
                fieldName: field,
                value: estNumberCalves,
              })
            }
          }
        }
      }

      for (let farm of this.FARMS) {
        let field = this.prefixedField('est_number_animals', farm.id, 'animallmdata')
        if (farm.id && [null, undefined].includes(this.getFieldValue(field))) {
          let estNumberHerd =
            this.getFieldValue(this.prefixedField('cows_wintered_incl_r2', farm.id), 'AnimalNumbers')
            // - this.getFieldValue(this.prefixedField('r2', farm.id), 'AnimalNumbers')
          if (estNumberHerd && estNumberHerd > 0) {
            this.setFieldValue({
              fieldName: field,
              value: estNumberHerd,
            })
          }
        }
      }

      let estNumberHeifers = this.FARMS.map((farm) => this.prefixedField('r2', farm.id))
        .map((field) => this.getFieldValue(field, 'AnimalNumbers') || 0)
        .reduce((partialSum, a) => partialSum + a, 0)

      if ([null, undefined].includes(this.getFieldValue('heifers_est_number_animals'))) {
        if (estNumberHeifers && estNumberHeifers > 0) {
          this.setFieldValue({
            fieldName: 'heifers_est_number_animals',
            value: estNumberHeifers,
          })
        }
      }
    },
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'wc-lepto-certificate-required',
        value: this.getFieldValue('is_lepto_vax_program_completed', this.$options.name),
      })

      // BVD monitoring requirements
      let fieldsToCheck = this.getFieldValue('FARMS', this.$options.name)
        .map((farm) => [
          this.prefixedField('wants_bvd_mon_lic', farm.id),
          this.prefixedField('wants_bvd_mon_gribbles', farm.id),
        ])
        .flat()

      this.setEmailNotification({
        slug: 'bvd-monitoring-requirements',
        value: fieldsToCheck.some((fieldName) => this.getFieldValue(fieldName, this.$options.name)),
      })
      // end BVD monitoring requirements
    },
  },
  computed: {
    vaxTypeOptions: function () {
      return ['7in1', 'Plain lepto', 'Lepto 4 way'].map((vax) => {
        return { value: vax.toLowerCase(), display: vax }
      })
    },
    monthOptions: function () {
      return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ].map((month) => {
        return { value: month.toLowerCase(), display: month }
      })
    },
  },
}
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
</style>
